import {
  CreateCdfParams,
  RawCdfEntry,
} from 'features/dataLayers/customCdfs/cdfGenerator'
import { useGetCustomCdfUpsertDeleteFns } from 'features/dataLayers/customCdfs/useGetCustomCdfUpsertDeleteFns'
import { RolodexCacheInstance } from 'features/rolodex'
import { useEffect, useId, useMemo, useState } from 'react'

export function useCreateCustomCdf(
  args: CreateCdfParams | null,
  rolodexCacheInstance: RolodexCacheInstance,
  customId: string | null = null
) {
  const reactId = useId()

  const { createCdfFn, tearDownCdfFn } =
    useGetCustomCdfUpsertDeleteFns(rolodexCacheInstance)

  const [cdfCreated, setCdfCreated] = useState<RawCdfEntry | undefined>()

  const newId = customId ?? `custom-cdf-${reactId}`

  useEffect(() => {
    if (!args) {
      setCdfCreated(undefined)
      return
    }

    const createdCdf = createCdfFn(newId, args)
    setCdfCreated(createdCdf)

    return () => {
      tearDownCdfFn(createdCdf.id)
    }
  }, [args, createCdfFn, newId, tearDownCdfFn])

  return useMemo(() => {
    return {
      id: cdfCreated?.id ?? null,
      entry: cdfCreated,
      isLoading: !!args && !cdfCreated,
    }
  }, [args, cdfCreated])
}
